module.exports = __webpack_public_path__ + "img/towing-truck-icon.3b876fe3.svg";